var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5001 0.75C14.8404 0.75 18.6775 2.90463 21 6.20261V9.29685C18.6775 12.5951 14.8403 14.75 10.4998 14.75C6.15954 14.75 2.32255 12.5954 0 9.29752V6.20311C2.32256 2.90497 6.15979 0.75 10.5001 0.75ZM10.4998 12.4167C7.2015 12.4167 4.25843 10.8959 2.33347 8.51735V6.98311C4.25693 4.60613 7.19709 3.0857 10.4925 3.08334C7.91859 3.08741 5.83333 5.17519 5.83333 7.75C5.83333 10.3273 7.92244 12.4167 10.4998 12.4167C10.4998 12.4167 10.4997 12.4167 10.4998 12.4167ZM18.6668 8.51643C16.7434 10.8937 13.8031 12.4143 10.5075 12.4167C13.0814 12.4126 15.1667 10.3248 15.1667 7.75C15.1667 5.17267 13.0773 3.08333 10.5 3.08333C10.5 3.08333 10.5 3.08333 10.5 3.08333C13.7985 3.08333 16.7419 4.60428 18.6668 6.98311V8.51643ZM12.8333 7.75C12.8333 9.03866 11.7887 10.0833 10.5 10.0833C9.21134 10.0833 8.16667 9.03866 8.16667 7.75C8.16667 6.46134 9.21134 5.41667 10.5 5.41667C11.7887 5.41667 12.8333 6.46134 12.8333 7.75Z",
    fill: "#39414A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.63ae81f9bb55f4e881fb5b7637e6ecb2.svg";
export { ForwardRef as ReactComponent };